// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"e5688cbd","179":"58714059","329":"523a1add","389":"5e6c1a36","596":"3396223c","735":"48594332"}[chunkId] + ".chunk.js";
};